/* eslint-disable */
import React from "react";
// INTERFACES
import { WriteInterface } from "../../../../../../interfaces/AdapterCdoOpc.interface";

export default function ComponentWrite({
	data,
	setData,
}: {
	data: WriteInterface;
	setData: (newValue: WriteInterface) => void;
}) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{/** ************************* */}
			{/** BODY */}
		</div>
	);
}
